import { Controller } from "@hotwired/stimulus";

// The layout's inline script removes an already-dismissed banner before paint.
// connect() repeats the check for a Turbo morph, which can put the banner back
// without running that script again.
const STORAGE_KEY = "odo-announcement-banner-dismissed";

// Connects to data-controller="announcement-banner"
export default class extends Controller {
	static values = { version: String };

	connect() {
		try {
			if (localStorage.getItem(STORAGE_KEY) === this.versionValue) this.element.remove();
		} catch {
			// Storage blocked: keep the banner.
		}
	}

	dismiss() {
		localStorage.setItem(STORAGE_KEY, this.versionValue);
		this.element.remove();
	}
}
